/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cutoffLabel: NonNullable<unknown>, timezone: NonNullable<unknown> }} Booking_CutoffInputs */

const en_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lessons must be booked by ${i?.cutoffLabel} ${i?.timezone} the day before. Same-day booking is not available.`)
};

const es_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Las lecciones deben reservarse antes de las ${i?.cutoffLabel} ${i?.timezone} del día anterior. No hay reservas el mismo día.`)
};

const de_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Golfstunden müssen spätestens am Vortag bis ${i?.cutoffLabel} Uhr ${i?.timezone} gebucht werden. Eine Buchung am selben Tag ist nicht möglich.`)
};

const zh_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`课程须在前一天${i?.timezone}${i?.cutoffLabel}前预订。不提供当日预订。`)
};

const ar_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يجب حجز الدروس بحلول ${i?.cutoffLabel} حسب ${i?.timezone} في اليوم السابق. الحجز في نفس اليوم غير متاح.`)
};

const fr_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les cours doivent être réservés la veille avant ${i?.cutoffLabel} (${i?.timezone}). La réservation le jour même n'est pas possible.`)
};

const vi_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buổi học phải được đặt trước ${i?.cutoffLabel} theo ${i?.timezone} ngày hôm trước. Không nhận đặt trong ngày.`)
};

const sw_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nafasi za masomo lazima ziwekwe siku iliyotangulia, kabla ya saa ${i?.cutoffLabel} (${i?.timezone}). Haiwezekani kuweka nafasi siku hiyo hiyo.`)
};

const th_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ต้องจองบทเรียนภายใน ${i?.cutoffLabel} ${i?.timezone} หนึ่งวันก่อน ไม่สามารถทำการจองในวันเดียวกันได้`)
};

const bs_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lekciju je potrebno rezervisati najkasnije dan ranije, do ${i?.cutoffLabel} (${i?.timezone}). Rezervacija istog dana nije dostupna.`)
};

const ja_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`レッスンは前日の${i?.cutoffLabel}（${i?.timezone}）までにご予約ください。当日のご予約はできません。`)
};

const ko_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`레슨은 전날 ${i?.cutoffLabel} ${i?.timezone}까지 예약해야 합니다. 당일 예약은 불가능합니다.`)
};

const pt_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As aulas devem ser reservadas até as ${i?.cutoffLabel} (${i?.timezone}) do dia anterior. Não é possível reservar no mesmo dia.`)
};

const it_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le lezioni vanno prenotate entro le ${i?.cutoffLabel}, ${i?.timezone}, del giorno prima. Non è possibile prenotare in giornata.`)
};

const sv_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lektioner måste bokas senast dagen innan kl. ${i?.cutoffLabel} (${i?.timezone}). Det går inte att boka samma dag.`)
};

const nl_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lessen moeten uiterlijk de dag ervoor om ${i?.cutoffLabel} ${i?.timezone} worden geboekt. Boeken op dezelfde dag is niet mogelijk.`)
};

const da_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lektioner skal bookes senest dagen før kl. ${i?.cutoffLabel} (${i?.timezone}). Booking samme dag er ikke muligt.`)
};

const nb_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timer må bestilles senest dagen før kl. ${i?.cutoffLabel} (${i?.timezone}). Bestilling samme dag er ikke mulig.`)
};

const fi_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tunnit on varattava edellisenä päivänä klo ${i?.cutoffLabel} mennessä, aikavyöhyke: ${i?.timezone}. Samana päivänä varaaminen ei ole mahdollista.`)
};

const pl_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lekcje należy zarezerwować najpóźniej dzień wcześniej do ${i?.cutoffLabel} (${i?.timezone}). Rezerwacja na ten sam dzień nie jest możliwa.`)
};

const ru_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Уроки нужно бронировать не позднее ${i?.cutoffLabel} (${i?.timezone}) накануне. Бронирование в тот же день недоступно.`)
};

const tr_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dersler en geç bir önceki gün saat ${i?.cutoffLabel} (${i?.timezone}) öncesinde ayırtılmalıdır. Aynı gün rezervasyon yapılamaz.`)
};

const hi_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पाठ एक दिन पहले ${i?.cutoffLabel} (${i?.timezone}) तक बुक करना ज़रूरी है। उसी दिन बुकिंग उपलब्ध नहीं है।`)
};

const id_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pelajaran harus dipesan paling lambat pukul ${i?.cutoffLabel} ${i?.timezone} sehari sebelumnya. Pemesanan di hari yang sama tidak tersedia.`)
};

const ms_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pelajaran mesti ditempah selewat-lewatnya pukul ${i?.cutoffLabel} ${i?.timezone} sehari sebelumnya. Tempahan pada hari yang sama tidak dibenarkan.`)
};

const cs_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lekce je nutné rezervovat nejpozději den předem do ${i?.cutoffLabel} (${i?.timezone}). Rezervace na tentýž den není možná.`)
};

const el_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Τα μαθήματα πρέπει να κλείνονται έως τις ${i?.cutoffLabel} (${i?.timezone}) της προηγούμενης ημέρας. Δεν είναι δυνατή η κράτηση για την ίδια ημέρα.`)
};

const he_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`יש להזמין שיעורים עד ${i?.cutoffLabel} לפי ${i?.timezone} ביום הקודם. לא ניתן להזמין באותו יום.`)
};

const af_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lesse moet teen ${i?.cutoffLabel} ${i?.timezone} die vorige dag bespreek word. Besprekings op dieselfde dag is nie beskikbaar nie.`)
};

const hu_booking_cutoff = /** @type {(inputs: Booking_CutoffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Az órákat legkésőbb az előző napon ${i?.cutoffLabel}-ig (${i?.timezone}) kell lefoglalni. Aznapi foglalás nem lehetséges.`)
};

/**
* | output |
* | --- |
* | "Lessons must be booked by {cutoffLabel} {timezone} the day before. Same-day booking is not available." |
*
* @param {Booking_CutoffInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_cutoff = /** @type {((inputs: Booking_CutoffInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_CutoffInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_cutoff(inputs)
	if (locale === "de") return de_booking_cutoff(inputs)
	if (locale === "zh") return zh_booking_cutoff(inputs)
	if (locale === "ar") return ar_booking_cutoff(inputs)
	if (locale === "fr") return fr_booking_cutoff(inputs)
	if (locale === "vi") return vi_booking_cutoff(inputs)
	if (locale === "sw") return sw_booking_cutoff(inputs)
	if (locale === "th") return th_booking_cutoff(inputs)
	if (locale === "bs") return bs_booking_cutoff(inputs)
	if (locale === "ja") return ja_booking_cutoff(inputs)
	if (locale === "ko") return ko_booking_cutoff(inputs)
	if (locale === "pt") return pt_booking_cutoff(inputs)
	if (locale === "it") return it_booking_cutoff(inputs)
	if (locale === "sv") return sv_booking_cutoff(inputs)
	if (locale === "nl") return nl_booking_cutoff(inputs)
	if (locale === "da") return da_booking_cutoff(inputs)
	if (locale === "nb") return nb_booking_cutoff(inputs)
	if (locale === "fi") return fi_booking_cutoff(inputs)
	if (locale === "pl") return pl_booking_cutoff(inputs)
	if (locale === "ru") return ru_booking_cutoff(inputs)
	if (locale === "tr") return tr_booking_cutoff(inputs)
	if (locale === "hi") return hi_booking_cutoff(inputs)
	if (locale === "id") return id_booking_cutoff(inputs)
	if (locale === "ms") return ms_booking_cutoff(inputs)
	if (locale === "cs") return cs_booking_cutoff(inputs)
	if (locale === "el") return el_booking_cutoff(inputs)
	if (locale === "he") return he_booking_cutoff(inputs)
	if (locale === "af") return af_booking_cutoff(inputs)
	if (locale === "hu") return hu_booking_cutoff(inputs)
	return en_booking_cutoff(inputs)
});